
const CreditCardButton = ({ price, onClick }) => {
  return (
    <div className="px-2">
      <button
        onClick={onClick}
        className="rounded-sm sm:text-[19px] text-sm p-3 bg-secondary100 text-primary100 text-center mt-4 cursor-pointer w-full"
        type="button"
      >
        Pay with credit card
      </button>
    </div>
  );
};

export default CreditCardButton;